// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1_OzV","cls2":"Modal-cls2__dT Modal-cls1_OzV"};